import { MNEMONICS } from 'constants/mnemonics';
import { ALL_DATA_MANAGEMENT_MNEMONICS } from 'constants/mnemonicsMapping';
import React from 'react';
import { useIntl } from 'react-intl';
import { MnemonicsMappingAndLiveStatusDTO } from 'types/mnemonicsMapping';

import styles from './LastTimestamp.module.scss';
import TimestampAndTimelapse from '../TimestampAndTimelapse';

interface Props {
  mnemonicsMapping?: MnemonicsMappingAndLiveStatusDTO;
  isFlowoutAVNA?: boolean;
  isFlowoutPCNA?: boolean;
  isFlowInBstNA: boolean;
}

const LastTimestamp: React.FC<Props> = ({
  mnemonicsMapping,
  isFlowoutAVNA,
  isFlowoutPCNA,
  isFlowInBstNA,
}) => {
  const intl = useIntl();

  const getFormattedLastTimestamp = (mnemonic: string) => {
    if (mnemonic === MNEMONICS.INCC) {
      const lastDepth = mnemonicsMapping?.depthData[MNEMONICS.INCC]?.lastMeasureDepth;

      return (
        <div className={styles.depth}>
          {lastDepth
            ? intl.formatMessage(
                { id: 'dataManagement.dataQuality.table.lastTimestampDepthLabel' },
                { lastDepth },
              )
            : ''}
        </div>
      );
    }
    if (mnemonic === MNEMONICS.FLOWOUTPC && isFlowoutPCNA) return;
    if (mnemonic === MNEMONICS.FLOWOUTAV && isFlowoutAVNA) return;

    if (mnemonic === MNEMONICS.FLOWIN_BST && isFlowInBstNA) return;

    const invalidDate = new Date();
    invalidDate.setHours(invalidDate.getHours() - 6);
    const lastTimestamp =
      mnemonicsMapping?.liveData[mnemonic] ??
      (mnemonicsMapping?.timeData[mnemonic]?.lastMeasureTime
        ? new Date(mnemonicsMapping?.timeData[mnemonic]?.lastMeasureTime) < invalidDate
          ? mnemonicsMapping?.timeData[mnemonic]?.lastMeasureTime
          : invalidDate.toString()
        : undefined);

    return <TimestampAndTimelapse timestamp={lastTimestamp} />;
  };

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th />
        </tr>
      </thead>
      <tbody>
        {ALL_DATA_MANAGEMENT_MNEMONICS.map(mnemonic => (
          <tr key={mnemonic}>
            <td className={styles.timestamp}>{getFormattedLastTimestamp(mnemonic)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LastTimestamp;
